import type { CSSProperties } from 'react';

import classNames from 'classnames';

import { getWidthStyle } from '@/utils/sizing';

import { computeColor } from '../utils/colors';

import { backgroundColors } from '../assets/colors';
import { ACCORDION_DEFAULTS } from './Accordion.constants';
import * as styles from './Accordion.css';
import type { AccordionContainerElementProps } from './Accordion.types';

export function AccordionContainerElement(props: AccordionContainerElementProps) {
  const { element, children, attributes, className } = props;

  const {
    background,
    borderColor,
    borderRadius,
    borderStyle,
    borderWidth,
    box_shadow,
    customAttributes,
    gap,
    padding,
    width,
    width_max,
  } = element.attrs || {};

  return (
    <div
      {...customAttributes}
      className={classNames(className, styles.accordionElement, customAttributes?.className)}
      style={
        {
          '--width': getWidthStyle(width, width_max).width,
          '--max-width': getWidthStyle(width, width_max).maxWidth,
          '--background-color': computeColor(background, backgroundColors) || ACCORDION_DEFAULTS.background,
          '--border-color': borderColor,
          '--border-radius': borderRadius,
          '--border-style': borderStyle,
          '--border-width': borderWidth,
          '--box-shadow': box_shadow ?? ACCORDION_DEFAULTS.boxShadow,
          '--gap': gap ?? ACCORDION_DEFAULTS.gap,
          '--padding': padding ?? ACCORDION_DEFAULTS.padding,
        } as CSSProperties
      }
      {...attributes}
    >
      {children}
    </div>
  );
}
